const ERROR_MESSAGE_KEYS = ['error_msg', 'error', 'message', 'detail'] as const

const getMessageFromPayload = (payload: unknown): string | undefined => {
  if (typeof payload === 'string') {
    const message = payload.trim()
    return message || undefined
  }

  if (!payload || typeof payload !== 'object') return undefined

  const record = payload as Record<string, unknown>
  for (const key of ERROR_MESSAGE_KEYS) {
    const value = record[key]
    if (typeof value === 'string' && value.trim()) return value.trim()
  }

  return undefined
}

/**
 * Returns the most useful user-facing message from Kubb v5 ResponseError,
 * legacy Axios errors, backend error envelopes, and ordinary Error objects.
 * Backend response text intentionally takes precedence over transport status text.
 */
export const getApiErrorMessage = (error: unknown, fallback = 'An error occurred'): string => {
  if (typeof error === 'string') return error.trim() || fallback
  if (!error || typeof error !== 'object') return fallback

  const errorRecord = error as Record<string, unknown>
  const response = errorRecord.response
  const responseData =
    response && typeof response === 'object'
      ? (response as Record<string, unknown>).data
      : undefined

  const backendMessage =
    getMessageFromPayload(errorRecord.data) ??
    getMessageFromPayload(responseData) ??
    getMessageFromPayload(errorRecord)

  if (backendMessage) return backendMessage
  if (error instanceof Error && error.message.trim()) return error.message.trim()

  return fallback
}
